import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d136d9c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "indexlayout-main-conent" }
const _hoisted_2 = { class: "title-border-bottom" }
const _hoisted_3 = { class: "h2-blue-underline" }
const _hoisted_4 = { class: "card-box" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = {
  key: 3,
  style: {"color":"#F59A23"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "********", -1))
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { key: 3 }
const _hoisted_14 = { class: "title-border-bottom" }
const _hoisted_15 = { class: "h2-blue-underline" }
const _hoisted_16 = { class: "ps-title" }
const _hoisted_17 = ["src"]
const _hoisted_18 = {
  key: 0,
  class: "mark-box"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"10px","font-size":"18px","color":"#fff"} }, "处理中，请稍等...", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_edit_outlined = _resolveComponent("edit-outlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_mobile_outlined = _resolveComponent("mobile-outlined")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_Personal = _resolveComponent("Personal")!
  const _component_Enterprise = _resolveComponent("Enterprise")!
  const _component_Password = _resolveComponent("Password")!
  const _component_Phone = _resolveComponent("Phone")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_card, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.t('page.personal.center.customer')), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_a_row, { gutter: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_row, {
                      class: "item",
                      gutter: 24
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, {
                          span: 6,
                          style: {"text-align":"right"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('page.personal.center.registered')) + "：", 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, { span: 16 }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString(_ctx.regEmail), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_row, {
                      class: "item",
                      gutter: 24
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, {
                          span: 6,
                          style: _normalizeStyle([{"text-align":"right"}, _ctx.certStatus == 4?{color:'#F59A23'}:{}])
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('page.personal.center.authstatus')) + "：", 1)
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_col, { span: 16 }, {
                          default: _withCtx(() => [
                            (_ctx.certStatus == 0 || _ctx.certStatus == 1 || _ctx.certStatus == 5)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.t('page.personal.center.notcertified')), 1))
                              : _createCommentVNode("", true),
                            (_ctx.certStatus == 2)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.t('page.personal.center.certifing')), 1))
                              : _createCommentVNode("", true),
                            (_ctx.certStatus == 3)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.t('page.personal.center.certified')), 1))
                              : _createCommentVNode("", true),
                            (_ctx.certStatus == 4)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.t('page.personal.center.certifiedfail')), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_row, {
                      class: "item",
                      gutter: 24
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, {
                          span: 6,
                          style: {"text-align":"right"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('page.personal.center.customernumber')) + "：", 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, { span: 16 }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString(_ctx.userCode), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_row, {
                      class: "item",
                      gutter: 24
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, {
                          span: 6,
                          style: {"text-align":"right"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('page.personal.center.password')) + "：", 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, { span: 16 }, {
                          default: _withCtx(() => [
                            _hoisted_9,
                            _createVNode(_component_a_button, {
                              type: "link",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleModify('pwd')))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_edit_outlined),
                                _createTextVNode(_toDisplayString(_ctx.t('page.personal.center.modify')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_row, {
                      class: "item",
                      gutter: 24
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, {
                          span: 6,
                          style: {"text-align":"right"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('page.personal.center.contractstatus')) + "：", 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, { span: 16 }, {
                          default: _withCtx(() => [
                            (_ctx.contStatus!==3&&_ctx.contStatus!==2)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.t('page.personal.center.notsigned')), 1))
                              : _createCommentVNode("", true),
                            (_ctx.contStatus==2&&_ctx.certStatus==3)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.t('page.personal.center.signeing')), 1))
                              : _createCommentVNode("", true),
                            ((_ctx.contStatus!==3&&_ctx.contStatus!==2)&&_ctx.certStatus==3)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                                  _createElementVNode("a", {
                                    style: {"margin-left":"10px"},
                                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleSignModal && _ctx.handleSignModal(...args)))
                                  }, _toDisplayString(_ctx.t('page.personal.center.clicksign')), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.contStatus==3&&_ctx.certStatus==3)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.t('page.personal.center.signed')), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_row, {
                      class: "item",
                      gutter: 24
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, {
                          span: 6,
                          style: {"text-align":"right"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('page.personal.center.phonebind')) + "：", 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, {
                          span: 16,
                          style: {"padding":"0"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.phone) + " ", 1),
                            (_ctx.phone=='')
                              ? (_openBlock(), _createBlock(_component_a_button, {
                                  key: 0,
                                  type: "link",
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleModify('bind')))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_mobile_outlined),
                                    _createTextVNode(_toDisplayString(_ctx.t('page.personal.center.clickbind')), 1)
                                  ]),
                                  _: 1
                                }))
                              : (_openBlock(), _createBlock(_component_a_button, {
                                  key: 1,
                                  type: "link",
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleModify('phone')))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_mobile_outlined),
                                    _createTextVNode(_toDisplayString(_ctx.t('page.personal.center.clickchange')), 1)
                                  ]),
                                  _: 1
                                }))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_a_card, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("h2", _hoisted_15, _toDisplayString(_ctx.t('page.personal.center.compontent.person.message')), 1)
          ]),
          _createVNode(_component_a_row, { style: {"margin-top":"30px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, {
                span: 4,
                style: {"text-align":"right"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.t('page.personal.center.customertype')) + "：", 1)
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 16 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_radio_group, {
                    value: _ctx.userType,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.userType) = $event)),
                    disabled: _ctx.certStatus==2||_ctx.certStatus==3,
                    onChange: _ctx.handleChange
                  }, {
                    default: _withCtx(() => [
                      (_ctx.userType != 0 || _ctx.userType != 2)
                        ? (_openBlock(), _createBlock(_component_a_radio, {
                            key: 0,
                            value: 1
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('page.personal.center.person')), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.userType != 0 || _ctx.userType != 1)
                        ? (_openBlock(), _createBlock(_component_a_radio, {
                            key: 1,
                            value: 2
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('page.personal.center.enterprise')), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["value", "disabled", "onChange"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 3 }),
              _createVNode(_component_a_col, {
                span: 16,
                style: {"color":"#AAAAAA","position":"relative","left":"-5px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode("温馨提示：目前不支持客户类型的修改，选择不同的类型需要上传不同的客户信息，请谨慎选择客户类型。")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.showflag)
            ? (_openBlock(), _createBlock(_component_Personal, {
                key: 0,
                onChangeCertStatus: _ctx.getStatus,
                phoneNumber: _ctx.phone
              }, null, 8, ["onChangeCertStatus", "phoneNumber"]))
            : _createCommentVNode("", true),
          (!_ctx.showflag)
            ? (_openBlock(), _createBlock(_component_Enterprise, {
                key: 1,
                onChangeCertStatus: _ctx.getStatus
              }, null, 8, ["onChangeCertStatus"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_a_modal, {
      title: _ctx.title,
      visible: _ctx.visible,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.visible) = $event)),
      maskClosable: false,
      footer: null,
      onOk: _ctx.handleVisible
    }, {
      default: _withCtx(() => [
        (_ctx.visible&&(_ctx.typeT=='pwd'))
          ? (_openBlock(), _createBlock(_component_Password, {
              key: 0,
              visible: _ctx.visible,
              "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.visible) = $event))
            }, null, 8, ["visible"]))
          : _createCommentVNode("", true),
        (_ctx.visible&&(_ctx.typeT=='bind' || _ctx.typeT=='phone'))
          ? (_openBlock(), _createBlock(_component_Phone, {
              key: 1,
              typeT: _ctx.typeT,
              visible: _ctx.visible,
              "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.visible) = $event)),
              onResClick: _ctx.getClickData
            }, null, 8, ["typeT", "visible", "onResClick"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["title", "visible", "onOk"]),
    _createVNode(_component_a_modal, {
      title: "法大大认证",
      width: "80%",
      visible: _ctx.fvisible,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.fvisible) = $event)),
      footer: null,
      maskClosable: false,
      onCancel: _ctx.handleCancel
    }, {
      default: _withCtx(() => [
        _createElementVNode("iframe", {
          src: _ctx.fddurl,
          frameborder: "0",
          class: "iframe"
        }, null, 8, _hoisted_17)
      ]),
      _: 1
    }, 8, ["visible", "onCancel"]),
    (_ctx.isMark)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createVNode(_component_a_spin),
          _hoisted_19
        ]))
      : _createCommentVNode("", true)
  ], 64))
}